import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=fca679d0&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=fca679d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca679d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca679d0')) {
      api.createRecord('fca679d0', component.options)
    } else {
      api.reload('fca679d0', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=fca679d0&scoped=true&", function () {
      api.rerender('fca679d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EFcO1nZJTSVk/JS/comp/GuestBox.vue"
export default component.exports